import type { Service } from '@/libs/interfaces'

import {
  MOCK_SERVICE_CATEGORY_ID_BRAKES,
  MOCK_SERVICE_CATEGORY_ID_DETAILING,
  MOCK_SERVICE_CATEGORY_ID_INSPECTION,
  MOCK_SERVICE_CATEGORY_ID_MAINTENANCE,
  MOCK_SERVICE_CATEGORY_ID_TIRES,
} from './categories'
import { MOCK_ORG_ID, MOCK_STORE_ID_1, MOCK_STORE_ID_2 } from './seed'

export const mockServices: Service[] = [
  {
    serviceID: 'service-1',
    colorForService: '#4F46E5',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    cost: 600,
    vatRate: 25,
    currency: 'SEK',
    name: 'Oil Change',
    serviceDescription: 'Oil and filter replacement',
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_MAINTENANCE,
    includeInAutomaticSms: true,
    hidden: false,
    warrantyCard: false,
    itemNumber: 'SVC-001',
    award: 150,
    serviceStatus: 'Active',
    serviceVariants: [
      {
        serviceVariantID: 'service-variant-1',
        serviceID: 'service-1',
        name: 'Standard Oil',
        award: 150,
        cost: 600,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_1,
        serviceVariantDays: [{ dayIndex: 0, duration: 60 }],
      },
      {
        serviceVariantID: 'service-variant-2',
        serviceID: 'service-1',
        name: 'Synthetic Oil',
        award: 200,
        cost: 800,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_1,
        serviceVariantDays: [{ dayIndex: 0, duration: 60 }],
      },
    ],
  },
  {
    serviceID: 'service-2',
    colorForService: '#16A34A',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    cost: 300,
    vatRate: 25,
    currency: 'SEK',
    name: 'Tire Rotation',
    serviceDescription: 'Rotate and balance all four tires',
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_TIRES,
    includeInAutomaticSms: false,
    hidden: false,
    warrantyCard: false,
    itemNumber: 'SVC-002',
    award: 100,
    serviceStatus: 'Active',
    serviceVariants: [
      {
        serviceVariantID: 'service-variant-3',
        serviceID: 'service-2',
        name: 'Standard Rotation',
        award: 100,
        cost: 300,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_1,
        serviceVariantDays: [{ dayIndex: 0, duration: 30 }],
      },
    ],
  },
  {
    serviceID: 'service-3',
    colorForService: '#DC2626',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    cost: 1200,
    vatRate: 25,
    currency: 'SEK',
    name: 'Brake Pad Replacement',
    serviceDescription: 'Front or rear brake pad replacement',
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_BRAKES,
    includeInAutomaticSms: true,
    hidden: false,
    warrantyCard: true,
    itemNumber: 'SVC-003',
    award: 350,
    serviceStatus: 'Active',
    serviceVariants: [
      {
        serviceVariantID: 'service-variant-4',
        serviceID: 'service-3',
        name: 'Front Pads',
        award: 350,
        cost: 1200,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_1,
        serviceVariantDays: [{ dayIndex: 0, duration: 90 }],
      },
      {
        serviceVariantID: 'service-variant-5',
        serviceID: 'service-3',
        name: 'Rear Pads',
        award: 350,
        cost: 1200,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_1,
        serviceVariantDays: [{ dayIndex: 0, duration: 90 }],
      },
    ],
  },
  {
    serviceID: 'service-4',
    colorForService: '#DC2626',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    cost: 1800,
    vatRate: 25,
    currency: 'SEK',
    name: 'Brake Disc Replacement',
    serviceDescription: 'Replace worn brake discs',
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_BRAKES,
    includeInAutomaticSms: true,
    hidden: false,
    warrantyCard: true,
    itemNumber: 'SVC-004',
    award: 500,
    serviceStatus: 'Active',
    serviceVariants: [
      {
        serviceVariantID: 'service-variant-6',
        serviceID: 'service-4',
        name: 'Standard Discs',
        award: 500,
        cost: 1800,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_1,
        serviceVariantDays: [{ dayIndex: 0, duration: 120 }],
      },
    ],
  },
  {
    serviceID: 'service-5',
    colorForService: '#0EA5E9',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    cost: 450,
    vatRate: 25,
    currency: 'SEK',
    name: 'Exterior Wash',
    serviceDescription: 'Hand wash and dry',
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_DETAILING,
    includeInAutomaticSms: false,
    hidden: false,
    warrantyCard: false,
    itemNumber: 'SVC-005',
    award: 120,
    serviceStatus: 'Active',
    serviceVariants: [
      {
        serviceVariantID: 'service-variant-7',
        serviceID: 'service-5',
        name: 'Standard Wash',
        award: 120,
        cost: 450,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_1,
        serviceVariantDays: [{ dayIndex: 0, duration: 45 }],
      },
    ],
  },
  {
    serviceID: 'service-6',
    colorForService: '#0EA5E9',
    storeID: MOCK_STORE_ID_2,
    orgID: MOCK_ORG_ID,
    cost: 900,
    vatRate: 25,
    currency: 'SEK',
    name: 'Full Interior Detailing',
    serviceDescription: 'Vacuum, shampoo and polish interior surfaces',
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_DETAILING,
    includeInAutomaticSms: false,
    hidden: false,
    warrantyCard: false,
    itemNumber: 'SVC-006',
    award: 280,
    serviceStatus: 'Active',
    serviceVariants: [
      {
        serviceVariantID: 'service-variant-8',
        serviceID: 'service-6',
        name: 'Full Detail',
        award: 280,
        cost: 900,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_2,
        serviceVariantDays: [{ dayIndex: 0, duration: 150 }],
      },
    ],
  },
  {
    serviceID: 'service-7',
    colorForService: '#F59E0B',
    storeID: MOCK_STORE_ID_2,
    orgID: MOCK_ORG_ID,
    cost: 500,
    vatRate: 25,
    currency: 'SEK',
    name: 'Annual Safety Inspection',
    serviceDescription: 'Full vehicle safety and diagnostic check',
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_INSPECTION,
    includeInAutomaticSms: true,
    hidden: false,
    warrantyCard: false,
    itemNumber: 'SVC-007',
    award: 150,
    serviceStatus: 'Active',
    serviceVariants: [
      {
        serviceVariantID: 'service-variant-9',
        serviceID: 'service-7',
        name: 'Standard Inspection',
        award: 150,
        cost: 500,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_2,
        serviceVariantDays: [{ dayIndex: 0, duration: 60 }],
      },
    ],
  },
  {
    serviceID: 'service-8',
    colorForService: '#F59E0B',
    storeID: MOCK_STORE_ID_2,
    orgID: MOCK_ORG_ID,
    cost: 250,
    vatRate: 25,
    currency: 'SEK',
    name: 'Diagnostic Check',
    serviceDescription: 'Computer diagnostics for engine warning lights',
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_INSPECTION,
    includeInAutomaticSms: false,
    hidden: false,
    warrantyCard: false,
    itemNumber: 'SVC-008',
    award: 90,
    serviceStatus: 'Active',
    serviceVariants: [
      {
        serviceVariantID: 'service-variant-10',
        serviceID: 'service-8',
        name: 'Standard Diagnostic',
        award: 90,
        cost: 250,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_2,
        serviceVariantDays: [{ dayIndex: 0, duration: 30 }],
      },
    ],
  },
  {
    serviceID: 'service-9',
    colorForService: '#16A34A',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    cost: 800,
    vatRate: 25,
    currency: 'SEK',
    name: 'Tire Change (Seasonal)',
    serviceDescription: 'Swap summer/winter tire sets',
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_TIRES,
    includeInAutomaticSms: true,
    hidden: false,
    warrantyCard: false,
    itemNumber: 'SVC-009',
    award: 250,
    serviceStatus: 'Active',
    serviceVariants: [
      {
        serviceVariantID: 'service-variant-11',
        serviceID: 'service-9',
        name: 'Standard Swap',
        award: 250,
        cost: 800,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_1,
        serviceVariantDays: [{ dayIndex: 0, duration: 45 }],
      },
    ],
  },
  {
    serviceID: 'service-10',
    colorForService: '#4F46E5',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    cost: 1500,
    vatRate: 25,
    currency: 'SEK',
    name: 'Full Service',
    serviceDescription: 'Complete maintenance service package',
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_MAINTENANCE,
    includeInAutomaticSms: true,
    hidden: false,
    warrantyCard: true,
    itemNumber: 'SVC-010',
    award: 450,
    serviceStatus: 'Active',
    serviceVariants: [
      {
        serviceVariantID: 'service-variant-12',
        serviceID: 'service-10',
        name: 'Full Service Package',
        award: 450,
        cost: 1500,
        currency: 'SEK',
        orgID: MOCK_ORG_ID,
        storeID: MOCK_STORE_ID_1,
        serviceVariantDays: [{ dayIndex: 0, duration: 180 }],
      },
    ],
  },
]
